import { createContext } from 'react';

export type OfferMessageTooltipState = {
  offerId: number;
  isVisible: boolean;
};

export type OfferMessageTooltipProps = {
  offerMessageTooltipState: OfferMessageTooltipState | null;
  rootRef: React.RefObject<HTMLDivElement | null>;
  showTooltip: (offerId: number) => void;
  hideTooltip: () => void;
};

export const OfferMessageTooltipContext = createContext<OfferMessageTooltipProps | undefined>(undefined);
